import type { Sparte } from '@/features/Global/types';

/**
 * „pkw-artige" KFZ-Sparte = KFZ-Sparte OHNE WKZ-Auswahl: festes Wagnis (WKZ 112),
 * hsn/tsn-basierte Fahrzeugerfassung, pkw-Fahrerkreis-Struktur. Ihr `allgemein`-Schema
 * (`allgemeinKfzSchema`) hat KEIN `wkz`-Feld — anders als die notPkw-KFZ-Sparten
 * (camp/campv2/krad/nutz), die über `allgemein.wkz` und WKZ-Choice-Meta laufen.
 *
 * Aktuell trifft das auf `pkw` (V1) und `pkwv2` (Fake-Sparte für die V2-Berechnung) zu.
 * Dieser Helper zentralisiert die zahlreichen `sparte === 'pkw'`-Sonderpfade im geteilten
 * KFZ-Code, damit pkwv2 überall wie pkw behandelt wird und die nächste wkz-lose Sparte
 * nur hier ergänzt werden muss.
 */
export const isPkwSparte = (sparte: Sparte | null | undefined): boolean =>
  sparte === 'pkw' || sparte === 'pkwv2';
